import React, { useState } from 'react';
import { Tabs, Tab, Box, Card, CardContent, Button } from '@mui/material';
import SeminalFluidAnalysis from './seminalFluidAnalysis';
import PostWashAnalysis from './postWashAnalysis';
import PatientDetails from './patientDetails';
import SemenAnalysis from './semenAnalysis';
import { styled } from '@mui/system';
import OtherDetails from './otherDetails';
import {
  createHSAReport,
  generateHSAReport,
  updateHSAReport,
} from '../../../../api/andrologyApi';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetAndrologyData,
  setAndrologyData,
} from '../../../../actions/andrologyAction';
import { checkFileAvailabilityApi } from '../../../../api/patientApi';
import { pollFileAvailability } from '../../../../api/utils';
import { DownloadForOfflineOutlined } from '@mui/icons-material';
import axios from 'axios';
import { toast } from 'sonner';
import UIModal from '../../../../components/UIElements/UIModal';
const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  borderRadius: '8px',
}));

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3),
  border: '1px solid #ddd',
  borderRadius: '8px',
}));

const HsaReport = ({ setIsReportSelected }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleNext = () => {
    if (selectedTab < 3) {
      setSelectedTab((prev) => prev + 1);
    }
  };

  const handleSaveAndNext = () => {
    if (!hsaData.id) {
      handleSave();
    } else {
      handleUpdate();
    }
    handleNext();
  };

  const handleBack = () => {
    if (selectedTab > 0) {
      setSelectedTab((prev) => prev - 1);
    }
  };

  const selectedPatientData = useSelector(
    (state) => state.andrologyReducer.selectedPatientData,
  );
  const hsaData = useSelector((state) => state.andrologyReducer.hsa);

  const dispatch = useDispatch();
  const handleSave = async () => {
    setButtonsDisabled(true);
    const res = await createHSAReport(selectedPatientData.patient.id, {
      ...hsaData,
      id: undefined,
    });
    dispatch(setAndrologyData('hsa', res.data));
    setButtonsDisabled(false);
  };

  const handleUpdate = async () => {
    setButtonsDisabled(true);
    const res = await updateHSAReport(selectedPatientData.patient.id, hsaData);
    dispatch(setAndrologyData('hsa', res.hsa));
    setButtonsDisabled(false);
  };
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(false);
  const handleGenerateReport = async () => {
    setIsDownloadDisabled(true);
    const res = await generateHSAReport(
      selectedPatientData.patient.id,
      hsaData.id,
    );
    // dispatch(resetAndrologyData());
    if (res && res.pdf && res.pdf.file) {
      setIsDownloadDisabled(false);
      toast.success('Report Generated');

      try {
        const presignedUrl = await pollFileAvailability(
          checkFileAvailabilityApi,
          res.pdf.file.bucketName,
          res.pdf.file.fileKey,
        );
        dispatch(setAndrologyData('hsa.reportId', res.pdf.file.id));
        downloadFile(presignedUrl, selectedPatientData.patient.id);
        toast.success('Report is downloaded successfully');
        dispatch(setAndrologyData('refresh', true));
      } catch (error) {
        setIsDownloadDisabled(false);
        console.error('Failed to get presigned URL:', error);
      } finally {
        setIsDownloadDisabled(false);
      }
    }
  };

  const downloadFile = async (presignedUrl, patientId) => {
    try {
      const response = await axios.get(presignedUrl, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${patientId}-hsa-report.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  const handleCancelStartReport = () => {
    setOpenConfirmModal(false);
  };
  return (
    <div className="theme-blush">
      <StyledCard>
        <CardContent>
          <StyledBox>
            <Tabs
              value={selectedTab}
              onChange={handleChange}
              aria-label="HSA Report Tabs"
            >
              <Tab label="Patient Details" />
              <Tab label="Seminal Fluid Analysis" />
              <Tab label="Semen Analysis" />
              {/* <Tab label="Post Wash Analysis" /> */}
              <Tab label="Other Details" />
            </Tabs>
            <Box mt={2}>
              {selectedTab === 0 && (
                <PatientDetails keyPath={'hsa.patientDetails'} />
              )}
              {selectedTab === 1 && (
                <SeminalFluidAnalysis keyPath={'hsa.seminalFluidAnalysis'} />
              )}
              {selectedTab === 2 && (
                <SemenAnalysis keyPath={'hsa.spermAnalysis'} />
              )}
              {/* {selectedTab === 3 && <PostWashAnalysis keyPath={'hsa.postWashAnalysis'} />} */}
              {selectedTab === 3 && (
                <OtherDetails keyPath={'hsa.otherDetails'} />
              )}
            </Box>
            <Box
              mt={4}
              display={'flex'}
              flexDirection={'row'}
              gap={'12px'}
              justifyContent={'end'}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsReportSelected(false);
                }}
                style={{ minWidth: '180px' }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBack}
                disabled={selectedTab === 0}
                style={{ minWidth: '180px' }}
              >
                Back
              </Button>
              {selectedTab != 3 ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveAndNext}
                  style={{ minWidth: '180px' }}
                >
                  Save And Next
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveAndNext}
                  style={{ minWidth: '180px' }}
                >
                  Save
                </Button>
              )}
              {/* {!hsaData.id && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  style={{ minWidth: '180px' }}
                  disabled={buttonsDisabled}
                >
                  Save
                </Button>
              )}
              {hsaData.id && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpdate}
                  style={{ minWidth: '180px' }}
                  disabled={buttonsDisabled}
                >
                  Save
                </Button>
              )} */}
              {selectedTab == 3 && (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ minWidth: '180px' }}
                  onClick={() => setOpenConfirmModal(true)}
                  disabled={isDownloadDisabled || buttonsDisabled}
                >
                  Generate Report
                </Button>
              )}
            </Box>
          </StyledBox>
        </CardContent>
      </StyledCard>
      <UIModal
        title="Please confirm?"
        body="Do you want to generate report? Report once generated can't be changed. Do you still want to go ahead?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={openConfirmModal}
        onClose={() => handleCancelStartReport()}
        onSave={() => {
          handleGenerateReport();
          setOpenConfirmModal(false);
        }}
      />
    </div>
  );
};

export default HsaReport;
